import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Input,
  DataGrid,
} from '../../../../components/index';
import {
  motivosBloqueio,
  getObject,
  tipoEntidade,
} from '../../../../utils/listsSelect';
import Masks from '../../../../utils/masks';

const DadosBloqueioDesbloqueio = (props) => {
  const addTipoBloqueioLabel = (tipo) => {
    const obj = getObject(motivosBloqueio, tipo);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  };

  const verificaSeCampoDesabilitado = () => {
    const { existeCompetenciaInicial } = { ...props.estadoFormulario };
    const { usuarioPossuiPermissaoDesbloqueio } = { ...props.estadoFormulario };
    const { acao } = { ...props.estadoFormulario };
    if (acao !== 'novo' && (existeCompetenciaInicial === false || usuarioPossuiPermissaoDesbloqueio === false)) {
      return true;
    }
    return false;
  };

  return (
    <React.Fragment>
      <DataGrid title="Dados do Ente Federativo" icon="ico-users" >
        {props.estadoFormulario.acao === 'novo' ?
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado()}
                label="Tipo"
                onChange={e => props.handleChange(e, 'tipoEntidade')}
                placeholder="Selecione a entidade"
                value={props.estadoFormulario.tipoEntidade}
                itemList={tipoEntidade}
                custom
                number
              />
            </Grid>
            {props.estadoFormulario.tipoEntidade === 2 ? (
              <Grid cols="4 4 4 4">
                <Input
                  label="UF"
                  onChange={e => props.handleChange(e, 'uf')}
                  placeholder="Selecione a UF"
                  value={props.estadoFormulario.uf}
                  itemList={props.carregaUfDosMunicipios()}
                  custom
                />
              </Grid>
              ) : ''}
            {props.estadoFormulario.tipoEntidade ? (
              <Grid cols="4 4 4 4">
                <Input
                  label="Nome"
                  name="idParticipante"
                  onChange={e => props.handleChangeComboNome(e, 'idParticipante')}
                  placeholder="Selecione o destinatário"
                  value={props.estadoFormulario.bloqueio.idParticipante}
                  itemList={props.listaFiltradaDestinatarios()}
                  custom
                />
              </Grid>
              ) : ''}
          </div>
            : ''}

        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled
              label="CNPJ"
              mask={Masks.cnpj}
              value={props.estadoFormulario.participante.cnpjEf}
            />
          </Grid>
        </div>

        { props.estadoFormulario.acao !== 'novo' &&
        <div className="row">
          <Grid cols="2 2 2 2">
            <Input
              disabled
              label="UF"
              value={props.estadoFormulario.participante.uf}
            />
          </Grid>
          <Grid cols="10 10 10 10">
            <Input
              disabled
              label="Participante"
              value={props.estadoFormulario.participante.nome}
            />
          </Grid>
        </div>}
      </DataGrid>
      <DataGrid title="Dados do Bloqueio" icon="ico-money">
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              disabled
              mask={Masks.competencia}
              label="Competência do Bloqueio"
              value={props.estadoFormulario.bloqueio.competenciaInicioBloqueio}
            />
          </Grid>
          <Grid cols="6 6 6 6">
            {props.estadoFormulario.acao === 'novo' ?
              <Input
                label="Motivo do Bloqueio"
                disabled={props.estadoFormulario.acao !== 'novo' ||
                verificaSeCampoDesabilitado()}
                error={!props.estadoFormulario.validadeCampos.tipoBloqueio}
                touched={props.estadoFormulario.touched}
                placeholder="Selecione o motivo do bloqueio"
                onChange={e => props.handleChange(e, 'tipoBloqueio')}
                value={props.estadoFormulario.bloqueio.tipoBloqueio}
                // itemList={motivosBloqueio}
                itemList={props.estadoFormulario.listaMotivosBloqueio}
                number
                custom
                required
              />
            :
              <Input
                label="Motivo do Bloqueio"
                disabled
                value={addTipoBloqueioLabel(props.estadoFormulario.bloqueio.tipoBloqueio)}
              />
            }
          </Grid>
        </div>
        {props.estadoFormulario.acao !== 'novo' ?
          <div className="row">
            <Grid cols="6 6 6 6">
              <Input
                disabled
                mask={Masks.competencia}
                label="Competência do Desbloqueio"
                value={props.estadoFormulario.bloqueio.competenciaFimBloqueio}
              />
            </Grid>
            <Grid cols="6 6 6 6">
              {!props.estadoFormulario.bloqueio.dataEncerramentoBloqueio ?
                <Input
                  label="Motivo do Desbloqueio"
                  disabled={props.estadoFormulario.bloqueio.dataEncerramentoBloqueio
                  || verificaSeCampoDesabilitado()}
                  error={!props.estadoFormulario.validadeCampos.tipoDesbloqueio}
                  touched={props.estadoFormulario.touched}
                  placeholder="Selecione o motivo do desbloqueio"
                  onChange={e => props.handleChange(e, 'tipoDesbloqueio')}
                  value={props.estadoFormulario.bloqueio.tipoDesbloqueio}
                  // itemList={motivosBloqueio}
                  itemList={props.estadoFormulario.listaMotivosDesbloqueio}
                  number
                  custom
                  required
                />
                :
                <Input
                  label="Motivo do Desbloqueio"
                  disabled
                  value={addTipoBloqueioLabel(props.estadoFormulario.bloqueio.tipoDesbloqueio)}
                />
              }
            </Grid>
          </div>
        : ''}
        {props.estadoFormulario.acao !== 'novo' ?
          <div className="row">
            <Grid cols="6 6 6 6">
              <Input
                disabled
                mask={Masks.date}
                label="Data de Inclusão do Bloqueio"
                value={props.estadoFormulario.bloqueio.dataInclusaoBloqueio}
              />
            </Grid>
            <Grid cols="6 6 6 6">
              <Input
                disabled
                mask={Masks.date}
                label="Data de Encerramento do Bloqueio"
                value={props.estadoFormulario.bloqueio.dataEncerramentoBloqueio}
              />
            </Grid>
          </div>
          : ''}
      </DataGrid>
    </React.Fragment>
  );
};

DadosBloqueioDesbloqueio.propTypes = {
  // acao: PropTypes.string.isRequired,
  // auth: PropTypes.objectOf(PropTypes.object).isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  listaFiltradaDestinatarios: PropTypes.func.isRequired,
  carregaUfDosMunicipios: PropTypes.func.isRequired,
  handleChangeComboNome: PropTypes.func.isRequired,
};

export default DadosBloqueioDesbloqueio;



// WEBPACK FOOTER //
// ./src/pages/cadastros/EntesFederativos/BloqueioDesbloqueio/DadosBloqueioDesbloqueio.jsx